import { ConfigurationSettings } from '/models/configuration-settings';
import { SiteConfigurationSettings } from '/models/site-configuration-settings';

const BLOCKS_BASE_URL = process.env.REACT_APP_PUBLIC_BLOCKS_BASE_URL || '';
const BLOCKS_LOGIC_BASE_URL = process.env.REACT_APP_PUBLIC_BLOCKS_LOGIC_BASE_URL || '';
const SELISE_AI_BASE_URL = process.env.REACT_APP_PUBLIC_SELISE_AI_BASE_URL || '';
const BLOCKS_KEY = process.env.REACT_APP_PUBLIC_BLOCKS_KEY || '';
const GOOGLE_CAPTCHA_SITE_KEY = process.env.REACT_APP_PUBLIC_GOOGLE_CAPTCHA_SITE_KEY || '';
const OAUTH_REDIRECT_BASE_URL = process.env.REACT_APP_PUBLIC_OAUTH_REDIRECT_BASE_URL || '';

const configurationSettings: ConfigurationSettings = {
  blocksKey: BLOCKS_KEY,
  googleCaptchaSiteKey: GOOGLE_CAPTCHA_SITE_KEY,
  paths: {
    baseUrl: BLOCKS_BASE_URL,
    logicBaseUrl: BLOCKS_LOGIC_BASE_URL,
    seliseAiBaseUrl: SELISE_AI_BASE_URL,
    seliseAi: {
      chatAll: '/conversation/chat/all',
      conversationList: '/conversation/conversations-list',
      singleConversation: '/conversation/single-conversation',
      archive: '/conversation/single-conversation/archive',
      unarchive: '/conversation/single-conversation/unarchive',
      uploadAll: '/files/upload/all',
      presignedUrl: '/files/presigned-url',
      presignedUrlComplete: '/files/presigned-url/complete',
      feedback: '/conversation/feedback',
      textToSpeech: '/text-to-speech',
      chatStream: '/conversation/chat/stream',
      generateTitle: '/conversation/generate-title',
      knowledgebase: '/knowledgebase/knowledgebase',
      projects: '/projects',
      integrationToken: '/integrations/token',
      integrationLimit: '/integrations/check-limit',
      integrationSync: '/integrations/sync',
      integrations: '/integrations/providers',
      integrationOverview: '/channels/overview',
      integrationConnectionCreate: '/channels/connections',
      integrationTelegramConnectionConfigure: '/channels/telegram/connections/:connectionId/configure',
      integrationTelegramConnectionActivate: '/channels/telegram/connections/:connectionId/activate',
      integrationTelegramConnectionDeactivate: '/channels/telegram/connections/:connectionId/deactivate',
      integrationWhatsAppConnectionConfigure: '/channels/whatsapp/connections/:connectionId/configure',
      integrationWhatsAppConnectionBind: '/channels/whatsapp/connections/:connectionId/bind',
      integrationWhatsAppConnectionActivate: '/channels/whatsapp/connections/:connectionId/activate',
      integrationWhatsAppConnectionDeactivate: '/channels/whatsapp/connections/:connectionId/deactivate',
      integrationTeamsConnectionConfigure: '/channels/teams/connections/:connectionId/configure',
      integrationTeamsConnectionActivate: '/channels/teams/connections/:connectionId/activate',
      integrationTeamsConnectionDeactivate: '/channels/teams/connections/:connectionId/deactivate',
      integrationTeamsConnectionTest: '/channels/teams/connections/:connectionId/test',
      integrationTeamsConnectionTestMessage: '/channels/teams/connections/:connectionId/test-message',
      integrationConnections: '/integrations/connections?status=active',
      deleteIntegrationConnection: '/integrations/connections',
      integrationConnectionInitiate: '/integrations/connections/initiate',
      integrationConnectionCallback: '/integrations/connections/callback',
      integrationConnectionBrowse: '/integrations/connections/:connectionId/browse',
      integrationConnectionSelections: '/integrations/connections/:connectionId/browse/selections',
      integrationConnectionResources: '/integrations/connections/:connectionId/resources',
      integrationConnectionSyncJobs: '/integrations/connections/:connectionId/sync-jobs',
      integrationSyncJobById: '/integrations/sync-jobs/:syncJobId',
      mediaFiles: '/media-library/media',
      documentManagerFilesUpload: '/document-manager/files/upload',
      documentManagerFiles: '/document-manager/files',
      documentManagerFilesShare: '/document-manager/files/share',
      documentManagerFilesUnshare: '/document-manager/files/unshare',
      documentManagerFilesDelete: '/document-manager/files/delete',
      updateReferenceChatHistoryStatus: '/knowledgebase/memory',
      suggestions: '/suggestions',
      transcribe: '/speech-to-text/transcribe',
      voiceSession: '/voice/session',
      invitation: '/invitation',
      collaboration: '/collaboration',
      getCollaborationMessages: '/collaboration/messages',
      collaborationConversation: '/collaboration/conversations',
      conversationProjects: '/projects',
      conversationProjectsCreate: '/projects/create',
      mediaLibrary: '/media-library',
      tts: '/text-to-speech',
      connectionDB: '/db-connections/connect',
      disconnectDBConnection: '/db-connections/disconnect',
      listDBConnections: '/db-connections',
      upsertDBConnection: '/db-connections/upsert',
      pipelineAnalytics: '/pipeline-analytics',
      tokenUsage: '/analytics/token-usage',
      customGpts: '/custom-gpts',
      conversationSessions: '/conversation/sessions',
      conversationSessionById: '/conversation/sessions',
      conversationLlmSessions: '/conversation/llm-sessions',
      conversationInitiate: '/conversation/initiate',
      aiAgentQueryStream: '/ai-agent/query/stream',
      aiAgentQuery: '/ai-agent/query',
      aiAgentQueryLmt: '/ai-agent/query-lmt',
      aiAgentQueryLmtStream: '/ai-agent/query-lmt/stream',
      aiAgentChat: '/ai-agent/chat',
      aiAgentFileProcess: '/ai-agent/file/process',
      agentsQueries: '/agents/queries',
      agentsModels: '/agents/models',
      agentsCreate: '/agents/create',
      agentsDelete: '/agents/delete',
      agentsQuery: '/agents/query',
      agentsChangeStatus: '/agents/change-status',
      agentsUpdatePersona: '/agents/update-persona',
      agentsUpdateAiConfig: '/agents/update-ai-configurations',
      agentsUpdateWidget: '/agents/update-widget',
      agentsWidgetColorSuggestion: '/agents/widget-color-suggestion',
      kbRetrievalTest: '/kb/retrieval-test',
      agentsPublish: '/agents/publish-agents',
      agentsGuardrails: '/agents/guardrails',
      agentsShare: '/agents',
      kbKnowledges: '/kb/knowledges',
      kbFile: '/kb/file',
      kbText: '/kb/text',
      kbLink: '/kb/link',
      kbQa: '/kb/qa',
      kbUpdate: '/kb/update',
      kbDelete: '/kb/delete',
      kbReembed: '/kb/reembed',
      kbFolderCreate: '/kb/folder/create',
      kbFolderUpdate: '/kb/folder/update',
      kbFoldersList: '/kb/folders/list',
      kbFolderDelete: '/kb/folder/delete',
      kbFolderAgents: '/kb/folder/agents',
      promptLibraryFoldersList: '/prompt-library/folders/list',
      promptLibraryFolderCreate: '/prompt-library/folder/create',
      promptLibraryFolderUpdate: '/prompt-library/folder/update',
      promptLibraryFolderDelete: '/prompt-library/folder/delete',
      promptLibraryPromptsList: '/prompt-library/prompts/list',
      promptLibraryPromptCreate: '/prompt-library/prompt/create',
      promptLibraryPromptUpdate: '/prompt-library/prompt/update',
      promptLibraryPromptDelete: '/prompt-library/prompt/delete',
      mentionsSearch: '/mentions/search',
      // taskforce's model catalogue — GET /models (no trailing slash).
      models: '/models',
      modelValidate: '/models/:id/validate',
      modelSeedProviders: '/models/seed/providers',
      modelSeedByProvider: '/models/seed/providers/:provider',
      // blocks_agent's LLM-config CRUD — GET /models/ (trailing slash).
      // Different endpoint, different shape; FastAPI keeps them separate
      // because redirect_slashes is off on the backend.
      customLlmModels: '/models/',
      tools: '/tools',
      scheduledJobs: '/scheduled-jobs',
      toolsDefaultsList: '/tools/defaults/list',
      toolApi: '/tools/api',
      toolMcpServer: '/tools/mcp-server',
      toolMcpServerImport: '/tools/mcp-server/import',
      toolComposio: '/tools/composio',
      toolComposioCatalog: '/tools/composio/catalog',
      toolComposioToolkits: '/tools/composio/toolkits',
      toolComposioToolkitTools: '/tools/composio/toolkits/:toolkit/tools',
      toolComposioConnections: '/tools/:toolId/composio/connections',
      toolComposioOauthCallback: '/composio/oauth/callback',
      toolOpenConnector: '/tools/open-connector',
      toolOpenConnectorCatalog: '/tools/open-connector/catalog',
      toolOpenConnectorServiceActions: '/tools/open-connector/services/:service/actions',
      toolOpenConnectorConnections: '/tools/:toolId/open-connector/connections',
      toolApiAuthConfig: '/tools/api-auth-config',
      toolApiAction: '/tools/api-action',
      toolSchemaOpenApi: '/tools',
      toolTestAction: '/tools',
      toolDeleteAction: '/tools',
      toolTutorial: '/tools/tutorial',
      toolSummary: '/tools',
      toolMcpServerSetup: '/tools/mcp-server-setup',
      toolRefreshMcp: '/tools',
      toolTestMcpAuth: '/tools',
      toolAgentCount: '/tools',
      toolDefaults: '/tools/defaults',
      toolCopyFromDefault: '/tools/copy-from-default',
      toolApprovalGrants: '/tools/grants',
      toolChatApprovalGrants: '/tools/grants/chat',
      skills: '/skills',
      chat: '/chat',
    },

    // Authentication — legacy /authentication/v1/* consolidated under /idp/v1/Authentication/*
    authentication: {
      getLoginOptions: '/iam/v4/auth/login-options',
      getSocialLogInEndPoint:
        '/iam/v4/auth/social/initiate?clientId=:clientId&redirectUri=:redirectUri',
      socialLogin: '/iam/v4/auth/social/callback',
      login: '/iam/v4/auth/login',
      refreshToken: '/iam/v4/auth/refresh',
      logout: '/iam/v4/auth/Logout',
      logoutAll: '/iam/v4/auth/LogoutAll',
      switchOrganization: '/iam/v4/auth/switch-org',
    },

    // Storage — /storage/v1 → /data/v1. keyRotation has no Blocks equivalent.
    storage: {
      getFile: '/logic/v4/Storage/GetFile',
    },

    // UILM (i18n localization) — exists at dev-blocksapi.selise.ai/uilm/v1/* (verified).
    uilm: {
      getUilmFile: '/localization/v4/Key/GetUilmFile',
      languageGets: '/localization/v4/Language/Gets',
      moduleGets: '/localization/v4/Module/Gets',
    },

    // IAM — legacy /iam/v1/* consolidated under /idp/v1/Iam/*.
    iam: {
      // IDP has no direct equivalent for user language preference; may need UpdateAccount instead.
      updateLanguage: '',
      getSessions: '/iam/v4/iam/GetSessions',
      getAccount: '/iam/v4/iam/me',
      createAccount: '/iam/v4/iam/users/create',
      updateAccount: '/iam/v4/user/Update',
      changePassword: '/iam/v4/auth/change-password',
      getRoles: '/iam/v4/iam/roles',
      activateAccount: '/iam/v4/auth/activate',
      recoverAccount: '/iam/v4/auth/recover',
      resetPassword: '/iam/v4/auth/reset-password',
      resendActivation: '/iam/v4/auth/resend-activation',
      getUsers: '/iam/v4/iam/users',
      getOrganization: '/iam/v4/iam/organizations/:organizationId',
      getOrganizations: '/iam/v4/iam/organizations/my',
      // Legacy had hard-delete (DisableUser/DeleteUser); IDP exposes only Deactivate (soft).
      disableUser: '/iam/v4/iam/users/deactivate',
      // No bulk-create in IDP; legacy /User/CreateBulk has no direct equivalent.
      createBulkUser: '',
      deleteUser: '/iam/v4/iam/users/deactivate',
      updateUserInfo: '/iam/v4/iam/users/:userId',
      getUserById: '/iam/v4/iam/users/:userId',
      updateUserAccess: '/iam/v4/iam/users/access',
      oidcUiConfig: '/iam/v4/idp/oidc-ui-config',
    },

    businessService: {
      modelConfigurationGets: '',
      getRedirectUrl: '',
      organizationGet: '',
      organizationGets: '',
      organizationSave: '',
      organizationUpdate: '',
      organizationUpdateStatus: '',
      getPlans: '',
      generateCheckoutLink: '',
      getBillingAddress: '',
      updateBillingAddress: '',
      cancelSubscription: '',
      getCurrentPlan: '',
      subscribeFreePlan: '',
      updateSubscription: '',
      upgradeSubscriptionPlanForUser: '',
      cancelAllUserSubscriptions: '',
      getUserModels: '',
      getWhiteLabelConfiguation: '',
      getCouponInfo: '',
      contactSales: '',
      getActiveCoupons: '',
      getPlanUpdatePrice: '',
      addOrUpdateUserGroup: '',
      getGroupsAndUsers: '',
      getGroupById: '',
      removeUserFromGroup: '',
      deleteGroup: '',
      getGroupsByIds: '',
      notificationGets: '',
      notificationUpdateVisibility: '',
      paymentCreate: '/utilities/v4/payments/create',
      subscriptionPlans: '/utilities/v4/subscription-plans',
      subscriptions: '/utilities/v4/subscriptions',
      currentSubscription: '/utilities/v4/subscriptions/current',
      previewQuantityChange: '/utilities/v4/subscriptions/{subscriptionId}/quantities/preview',
      updateQuantity: '/utilities/v4/subscriptions/{subscriptionId}/quantities',
      subscriptionBillingProfile: '/utilities/v4/subscription-billing-profile',
      subscriptionDiscountPreview: '/utilities/v4/subscription-discounts/preview',
      subscriptionUsage: '/utilities/v4/subscription-usage/current',
    },

    // Identifier signup — no public signup endpoint in IDP. IDP has /Iam/Create and the
    // SignUpSetting endpoints (admin). Public self-signup flow is intentionally disabled here;
    // emailSignUpEnabled is set to false below.
    identifier: {
      signup: '',
    },

    // MFA — OTP/TOTP under idp; project MFA config under iam
    mfa: {
      generateOTP: '/iam/v4/Mfa/Generate',
      verifyOTP: '/iam/v4/Mfa/Verify',
      configureUserMfa: '/idp/v4/Mfa/ConfigureUserMfa',
      setUpTotp: '/iam/v4/Mfa/totp/setup',
      verifyTotpSetup: '/iam/v4/Mfa/totp/Verify-setup',
      resendOTP: '/iam/v4/Mfa/Resend',
      getConfiguration: '/iam/v4/MFA/Config',
      disableUserMfa: '/iam/v4/Mfa/Disable',
    },

    subscriptionPrivacyPolicyUrlDE: 'https://www.selisegroup.com/datenschutzbestimmungen/',
    subscriptionPrivacyPolicyUrlEN: 'https://www.selisegroup.com/en/privacy-policy/',
    subscriptionSupportUrlEN: 'https://www.selisegroup.com/en/lets-connect/',
    subscriptionSupportUrlDE: 'https://www.selisegroup.com/lassen-sie-uns-verbinden/',
    subscriptionTermsOfServiceUrlDE: '',
    subscriptionTermsOfServiceUrlEN: '',
    emailSignUpEnabled: false,
    oauthRedirectBaseUrl: OAUTH_REDIRECT_BASE_URL,
    integrationAppApiUri: 'https://api.integration.selisegroup.com',
    integrationAppUiUri: 'https://ui.integration.selisegroup.com',
    salesContactMailTo: 'info@selisegroup.com',
  },
};

const siteConfigurationSettings: SiteConfigurationSettings = {
  siteConfigurations: {
    data: {
      // reCAPTCHA key unchanged — FE is still hosted at app.selise.ai.
      siteKey: '6LcN-1ErAAAAAKUyRurb6Us7O6C69-O0sM7qcXRc',
      // Subscription/billing UI hidden in the Blocks ecosystem (no seliseai backend).
      showSubscriptionInfo: false,
    },
  },
};

export const getConfigurationSettings = async (): Promise<ConfigurationSettings> =>
  configurationSettings;

export const getSiteConfigurationSettings = async (): Promise<SiteConfigurationSettings> =>
  siteConfigurationSettings;
